//백엔드에서 보내주는 에러스펙 이외에, 프론트 에러처리가 필요할 때 정의해서 사용

const getGroupCode = (code) => {
  return code * 10000;
};

const getErrorCode = (groupCode, value) => {
  return groupCode + value;
};

const GROUP = {
  COMMON: 0,
  HR: 1,
  ATTENDANCE: 2,
  VACATION: 3,
  APPROVAL: 4,
  PROJECT: 5,
  NOTICE: 6,
};

const ERROR_SPEC = {
  COMMON: {
    REQUEST_FAIL: getErrorCode(getGroupCode(GROUP.COMMON), 0),
    RESPONSE_FAIL: getErrorCode(getGroupCode(GROUP.COMMON), 1),
    INVALID_INPUT: getErrorCode(getGroupCode(GROUP.COMMON), 2),
    NEED_INPUT: getErrorCode(getGroupCode(GROUP.COMMON), 3),
  },
  HR: {
    NEED_INPUT: getErrorCode(getGroupCode(GROUP.HR), 0),
  },
  ATTENDANCE: {},
  VACATION: {},
  APPROVAL: {},
  PROJECT: {},
  NOTICE: {},
};

Object.freeze(ERROR_SPEC);
Object.freeze(GROUP);

export default ERROR_SPEC;
